import {
  Box,
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useAnalyzer } from 'features/analyzers/api/getAnalyzer';
import SnapshotList from 'features/snapshots/SnapshotList';
import React from 'react';
import { useUserPermissionSettings } from './api/getUserPermissionSettings';
import { Snapshot, Analyzer } from 'types';
import { useSnapshots } from 'features/snapshots/api/getSnapshots';

interface Props {
  analyzerId: number;
  updateAnalyzerPermissions: (analyzerId: number, checked: boolean) => void;
  updateSnapshotPermissions: (snapshotId: number, checked: boolean) => void;
  checkIfAnalyzerSelected: (analyzer: Analyzer) => boolean;
  checkIfSnapshotSelected: (snapshot: Snapshot) => boolean;
  getFilterSnapshots: (snapshots: Snapshot[]) => () => Snapshot[];
}

const AnalyzerPermissionsContainer = ({
  analyzerId,
  updateAnalyzerPermissions,
  updateSnapshotPermissions,
  checkIfAnalyzerSelected,
  checkIfSnapshotSelected,
  getFilterSnapshots,
}: Props) => {
  const { data: permissionSettings } = useUserPermissionSettings({});
  const { data: analyzer } = useAnalyzer({ analyzerId });
  const { data: snapshotsForAnalyzer } = useSnapshots({ analyzerId });

  const handleSnapshotChecked = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, checked } = event.target;
    updateSnapshotPermissions(Number(name), !!checked);
  };

  const handleAnalyzerChecked = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, checked } = event.target;
    updateAnalyzerPermissions(Number(name), !!checked);
    if (
      !!permissionSettings?.snapshot_compartmentalization &&
      snapshotsForAnalyzer
    ) {
      for (const snapshot of snapshotsForAnalyzer) {
        updateSnapshotPermissions(snapshot.id, !!checked);
      }
    }
  };

  if (!analyzer) return null;

  return (
    <React.Fragment key={analyzerId}>
      <ListItem key={analyzerId} button>
        <ListItemIcon>
          <Checkbox
            edge='start'
            name={analyzerId.toString()}
            onChange={handleAnalyzerChecked}
            checked={checkIfAnalyzerSelected(analyzer)}
          />
        </ListItemIcon>
        <ListItemText>{analyzer.name}</ListItemText>
      </ListItem>

      {!!permissionSettings?.snapshot_compartmentalization && (
        <Box sx={{ pl: '2rem' }}>
          <SnapshotList
            getFilterSnapshots={getFilterSnapshots}
            analyzerId={analyzer.id}
            checkIfSnapshotSelected={checkIfSnapshotSelected}
            handleSnapshotChecked={handleSnapshotChecked}
            disabled={false}
          />
        </Box>
      )}
    </React.Fragment>
  );
};

export default AnalyzerPermissionsContainer;
